import { fonts } from '@local/web-design-system/dist/styles';
import { makeStyles } from 'tss-react/mui';
export const useStyles = makeStyles()((theme) => ({
    form: {
        width: '100%',
    },
    container: {
        margin: '0 auto',
        [theme.breakpoints.up('md')]: {
            maxWidth: theme.spacing(44.75),
        },
    },
    error: {
        marginBottom: theme.spacing(1),
    },
    formButton: Object.assign(Object.assign({}, fonts.button), { width: '100%', height: theme.spacing(5), backgroundColor: '#265794', textTransform: 'none', '&:disabled': {
            backgroundColor: theme.palette.grey[800],
            opacity: 0.8,
        } }),
    buttonText: {
        color: theme.palette.common.white,
    },
    buttonDisabled: {
        color: theme.palette.grey[400],
    },
    dividerText: {
        color: 'white',
        padding: `0 ${theme.spacing(2)}`,
    },
    divider: {
        color: 'white',
        height: '16px',
        width: '100%',
        flex: 1,
        borderTopColor: theme.palette.grey[300],
        marginTop: theme.spacing(1),
    },
    idButton: {
        color: 'white',
        backgroundColor: theme.palette.grey[700],
        width: '100%',
        height: theme.spacing(5),
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            opacity: 0.8,
        },
    },
}));
//# sourceMappingURL=LoginForm.styles.js.map